import React, { Component } from 'react'
import Header from '../components/header'
import Spotlight from '../components/spotlight'
import Resume from '../components/resume'
import { BELIZ } from '../utils/colors'


import dex1 from '../media/dex1.png'
import dex2 from '../media/dex2.png'
import dex3 from '../media/dex3.png'
import dex4 from '../media/dex4.png'
import dex5 from '../media/dex5.png'

import kingsway1 from '../media/kingsway1.png'
import kingsway2 from '../media/kingsway2.png'
import kingsway3 from '../media/kingsway3.png'

import bibleminded1 from '../media/bibleminded1.png'
import bibleminded2 from '../media/bibleminded2.png'
import bibleminded3 from '../media/bibleminded3.png'

import biblereader1 from '../media/biblereader1.png'
import biblereader2 from '../media/biblereader2.png'
import biblereader3 from '../media/biblereader3.png'
import biblereader4 from '../media/biblereader4.png'

import whereami1 from '../media/whereami1.png'
import whereami2 from '../media/whereami2.png'
import whereami3 from '../media/whereami3.png'
import whereami4 from '../media/whereami4.png'
import whereami5 from '../media/whereami5.png'

import chinablitz from '../media/chinablitz.mov'



class Portfolio extends Component {

    render() {
        return (
            <div className='container'>

                <Header title='Examples' subtitle='Just a preview of some of my favorites.' />

                <Resume />

                <div className='container' style={{padding: '2em', border: `solid 8px ${BELIZ}`}}>

                    <Spotlight
                        title='Dex'
                        description='Currently under development - This app is built with React Native, utilizing some great open source frameworks such as Realm Database for storage.  It also features original graphics/artwork.'
                        images={[dex1, dex2, dex3, dex4, dex5]} />
                    <hr style={{border: `solid 2px ${BELIZ}`}}/>

                    <Spotlight
                        title='Kingsway Pools'
                        description='This website was built using Angular 1.X.  It contains routing, lazy loading images, and is responsive for all screen sizes.'
                        link={{name: 'Kingsway Pools', uri: 'http://kingswaypools.com'}}
                        wide={true}
                        images={[kingsway1, kingsway2, kingsway3]} />
                    <hr style={{border: `solid 2px ${BELIZ}`}}/>

                    <Spotlight
                        title='China Blitz'
                        description='This is a 2D game developed on Windows for PC utilizing the DirectX 9.0 framework.  It utilizes the Box2d framework and original graphics/artwork.'
                        images={[]}
                        video={chinablitz} />
                    <hr style={{border: `solid 2px ${BELIZ}`}}/>

                    <Spotlight
                        title='Where Am I?'
                        description='This app is a cordova built application that is used to find out information about where the user is located geographically.  This info can be shared or saved for future reference.  It utilizes the Mapbox and Google reverse geocoding APIs.  It is built with Maquette js for views, Leaflet for map interaction, and ForerunnerDB for storage.  This app is currently being rebuilt with React Native.'
                        images={[whereami1, whereami2, whereami3, whereami4, whereami5]} />
                    <hr style={{border: `solid 2px ${BELIZ}`}}/>

                    <Spotlight
                        title='BibleMinded'
                        description='This app is a cordova built application that is used to help memorize bible verses.  I utilized the Maquette js framework for rendering/animating views and ForerunnerDB for database updating/syncing.'
                        images={[bibleminded1, bibleminded2, bibleminded3]} />
                    <hr style={{border: `solid 2px ${BELIZ}`}}/>

                    <Spotlight
                        title='Bible Reader'
                        description='This app is a cordova built application that is used to read and search the bible.  This is a Backbone js application for both rendering and database usage.'
                        images={[biblereader1, biblereader2, biblereader3, biblereader4]} />

                </div>

            </div>
        )
    }

}


export default Portfolio



// WEBPACK FOOTER //
// ./src/screens/portfolio.js